function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 3.55556C8.49091 3.55556 8.88889 3.86057 8.88889 5.33333V7.41613C8.88889 7.77947 8.88889 7.96113 8.95655 8.12449C9.02421 8.28784 9.15267 8.4163 9.40959 8.67321L10.0381 9.30175C11.0795 10.3432 11.0138 10.8402 10.6667 11.1874C10.3195 11.5345 9.82245 11.6002 8.78105 10.5588L8.15251 9.93029C7.63868 9.41646 7.38176 9.15954 7.24644 8.83284C7.11111 8.50613 7.11111 8.1428 7.11111 7.41613V5.33333C7.11111 3.86057 7.50907 3.55556 8 3.55556Z",
  fill: "#9CA5BA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM14.2222 8C14.2222 11.4364 11.4364 14.2222 8 14.2222C4.56356 14.2222 1.77778 11.4364 1.77778 8C1.77778 4.56356 4.56356 1.77778 8 1.77778C11.4364 1.77778 14.2222 4.56356 14.2222 8Z",
  fill: "#9CA5BA"
});

function SvgIconStatusInQueue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatusInQueue);
export default __webpack_public_path__ + "static/media/icon-status-in-queue.62964a1e.svg";
export { ForwardRef as ReactComponent };